/**
 * Window events between the API client and the UI:
 *   SESSION_EXPIRED_EVENT  — a refresh failed: the session is gone (SessionExpiredModal asks for the password)
 *   SESSION_RESTORED_EVENT — the user logged in again from that dialog (pages retry what failed)
 */
export const SESSION_EXPIRED_EVENT = 'tender:session-expired';
export const SESSION_RESTORED_EVENT = 'tender:session-restored';

export const announceSessionExpired = () => window.dispatchEvent(new Event(SESSION_EXPIRED_EVENT));
